import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { HttpLaravelHeaders } from '@app/_interceptors/url.interceptor';
import { ResponseObject } from '@app/_shared/interfaces';
import { Orders } from '@app/_shared/interfaces/http/statistics/orders';

@Injectable({
  providedIn: 'root',
})
export class OrdersService {
  private _http = inject(HttpClient);

  private headers = new HttpLaravelHeaders();

  private endpoint = '/api/v1/user/statistics/orders';

  index(params?: HttpParams) {
    return this._http.get<ResponseObject<Orders>>(this.endpoint, {
      headers: this.headers,
      params,
    });
  }
}
